import React, { useEffect, useState } from "react";
import Reactportal from "../../Reactportal/Reactportal";
import PortalFooter from "../../Reactportal/PortalFooter";
import { useModalContext } from "../../Reactportal/ModalContext";
import TrackingMap from "./components/TrackingMap/TrackingMap";
import { useSelector } from "react-redux";

const MyShipmentMap = ({ show, id, TypeOfPortal, submitType, ParentPortalCloseFunction }) => {
  const { pushModal, popModal, getTopModal } = useModalContext();
  const [toggle, settoggle] = useState(true);
  const Form_Key = "Shipment_Tracking"
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.[`Shipment_Tracking`]?.Selected_Row;

    useEffect(() => {
      pushModal(Form_Key);
      return () => {
        popModal(Form_Key)
      }
    }, []);
  const footerContent = (
    <PortalFooter
    Form_key={Form_Key}
    TypeOfPortal={TypeOfPortal}
    
      handleformclose={() => {
        ParentPortalCloseFunction()
        settoggle(!toggle);
        ParentPortalCloseFunction();
      }}
    />
  );
  return (
    <Reactportal
      Form_Key="Shipment_Tracking"
      FoooterContent={footerContent}
      TypeOfPortal={"Detail Shipment Track"}
      open={toggle}
      onClose={() => {
        settoggle(!toggle);
        popModal("Shipment_Tracking");
        ParentPortalCloseFunction();
      }}
    >
      <div>
        <TrackingMap trackID={fielddata?._id} />
      </div>
    </Reactportal>
  );
};

export default MyShipmentMap;
